// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InstrumentSearchInput_wrapper__vpRXy"};